<template>
  <vs-row>
    <vs-col vs-lg="4" vs-sm="4" vs-xs="12" style="padding: 5px">
      <v-select
        :style="this.backgroundStyle"
        label="label"
        :taggable="true"
        :options="options"
        :value="this.optionsCounter"
        :clearable="false"
        @option:created="addOption"
        @option:selecting="removeOption"
        :closeOnSelect="false"
        :resetOnOptionsChange="false"
      >
        <template #no-options>
          <span>Type and hit enter to add options</span>
        </template>
        <template #option="{ label }">
          <vs-row>
            <vs-col vs-w="4">
              {{label}}
            </vs-col>
            <vs-col v-if="editable" vs-w="1" vs-offset="7">
              <span style="font-size: 15px; color: red;">x</span>
            </vs-col>
          </vs-row>
        </template>
      </v-select>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: "CustomOptions",
  props: {
    initOptions: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      options: [...this.initOptions],
    };
  },
  computed: {
    optionsCounter () {
      let optionsCount = this.options.length;
      let plural = optionsCount > 1;
      return optionsCount > 0
        ? `${optionsCount} option${plural ? "s" : ""}`
        : 'Add options';
    },
    backgroundStyle () {
      return this.editable ? {} : {'background-color': '#f8f8f8'};
    }
  },
  methods: {
    addOption (newOption) {
      this.options = [...this.options, newOption];
    },
    removeOption (selected) {
      if (this.editable)
        this.options = this.options.filter((o) => o != selected);
    },
  },
  watch: {
    options: {
      handler: function (optionsUpdated) {
        this.$emit("optionsUpdated", optionsUpdated);
      }
    }
  }
};
</script>
